/**
 * The plugin key form takes websites as free text, one per line (commas work
 * too). The API normalizes and validates each one, so this only splits and trims.
 */
export const parseWebsites = (text: string): string[] =>
  text
    .split(/[\n,]/)
    .map((website) => website.trim())
    .filter((website) => website.length > 0)

/** The stored websites back as form text, one per line. */
export const formatWebsites = (origins: string[]): string => origins.join('\n')
